import React from "react";
import styles from "../ProgresBar/BarraProgreso.module.css";
import styled from "styled-components";
//aqui llamar total

const Barra = styled.div`
  height: 10px;
  background: #bababa;
  border-radius: 12px;
  position: relative;
  margin-left: -4px;
  margin-top: 13px;
  display: flex;
  width: 70%;
`;

const Porcentaje = styled.div`
  height: 20px;
  background: #532ca0;
  border-radius: 14px;
  position: relative;
  top: -7px;
  width: ${(props) => props.width + "%"};
`;

const PorcentajeInicial = styled.p`
  margin: 0;
  font-weight: bold;
  font-size: 22px;
  line-height: 32px;
  color: #532ca0;
  margin-left: -50px;
  margin-bottom: -20px;
`;
const valorFinal = 100;

const PorcentajeFinal = styled.p`
  margin: 0;
  font-weight: bold;
  font-size: 22px;
  line-height: 32px;
  color: ${(props) => (props.total === 100 ? "#532CA0;" : "#BABABA;")};
  margin-left: -30% !important;
  margin-top: -30px;
`;

const BarraProgreso = (props) => {
  return (
    <div className={styles["accion-barra"]}>
      <PorcentajeInicial>{props.total.toFixed(2)}%</PorcentajeInicial>
      <div className={styles["barraprogreso"]}>
        <Barra>
          <Porcentaje width={props.total}></Porcentaje>
        </Barra>
      </div>
      <PorcentajeFinal total={props.total}>
        {valorFinal}%
      </PorcentajeFinal>
    </div>
  );
};

export default BarraProgreso;
